import * as ko from "knockout";
import entityBase from "entityBase";
import { attachment_wrapper } from "../attachment/request_attachment";
import { solution_text } from "./solution_text";
import { solution_keyword } from "./solution_keyword";
import { solution_request } from "./solution_request";
import { request_dto } from "../request/request_dto";

export class solution_dto extends entityBase {
  //
  solution_id: KnockoutObservable<string>;
  title: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  content: KnockoutObservable<string>;
  weight: KnockoutObservable<number>;
  solution_status: KnockoutObservable<string>;
  ranking: KnockoutObservable<number>;

  solution_attachment: KnockoutObservableArray<attachment_wrapper>;
  solution_request: KnockoutObservableArray<solution_request>;
  solution_keyword: KnockoutObservableArray<solution_keyword>;
  solution_text: KnockoutObservableArray<solution_text>;
  c_portal_solutions_requests_view: KnockoutObservableArray<request_dto>;
  phencodes: KnockoutObservable<string>;

  // ui observables
  isCollapsed: KnockoutObservable<boolean>;
  isTitleCollapsed: KnockoutObservable<boolean>;

  activeClass: KnockoutComputed<string>;

  constructor(item?: any) {
    super();
    this.solution_id = ko.observable(item?.solution_id);
    this.title = ko.observable(item?.title);
    this.model_id = ko.observable(item?.model_id);
    this.description = ko.observable(item?.description);
    this.content = ko.observable(item?.content);
    this.solution_status = ko.observable(item?.solution_status);

    const weight = item?.solution_weight || item?.weight_adj;
    this.weight = ko.observable(parseFloat(weight) || 0);

    const ranking = item?.solution_ranking || item?.ranking;
    this.ranking = ko.observable(ranking || 0);

    this.isCollapsed = ko.observable(true);
    this.isTitleCollapsed = ko.observable(true);
    this.phencodes = ko.observable();
    this.activeClass = ko.computed(() => {
      return !this.isCollapsed() ? "active-solution-row" : "";
    });
    this.solution_attachment = ko.observableArray();
    this.solution_request = ko.observableArray();
    this.solution_keyword = ko.observableArray();
    this.solution_text = ko.observableArray();
    this.c_portal_solutions_requests_view = ko.observableArray();

    if (item?.solution_attachment) {
      this.solution_attachment = <KnockoutObservableArray<attachment_wrapper>>(
        this.loadRelation(item, attachment_wrapper, "solution_attachment", "array")
      );
    }
    if (item?.solution_text) {
      this.solution_text = <KnockoutObservableArray<solution_text>>(
        this.loadRelation(item, solution_text, "solution_text", "array")
      );
    }
    if (item?.solution_keyword) {
      this.solution_keyword = <KnockoutObservableArray<solution_keyword>>(
        this.loadRelation(item, solution_keyword, "solution_keyword", "array")
      );
    }
    if (item?.solution_request) {
      const comments = <KnockoutObservableArray<solution_request>>(
        this.loadRelation(item, solution_request, "solution_request", "array")
      );

      // display only requests that are in user place_id (has request property not null)
      comments(comments().filter((c) => c.request && c.request()));
      this.solution_request = comments;
    }
    if (item?.c_portal_solutions_requests_view) {
      this.c_portal_solutions_requests_view = <KnockoutObservableArray<request_dto>>(
        this.loadRelation(item, request_dto, "c_portal_solutions_requests_view", "array")
      );
    }
    if (item?.phencodes) {
      let phencodes = [];
      item?.phencodes?.forEach((code) => {
        const codes = code?.phencodes?.split("\r\n");
        phencodes = [...phencodes, ...codes];
      });
      this.phencodes(phencodes.join(", "));
    }
  }
}
